module.exports = __webpack_public_path__ + "files/77d5706d32f7dad20638b101f3b0f485.png";